<div class="modal" tabindex="-1" role="dialog" #modalConfirmed>
  <div class="modal-dialog modal-dialog-centered modal-fullscreen" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [innerText]="'ENQUIRIES.CONFIRMED_MODAL_SELECT_COTATION' | translate"></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'GENERAL.CLOSE' | translate"></button>
      </div>

      <div class="modal-body">
        @if (lines.length) {
          <div class="accordion accordion-flush quotations-accordion" [id]="accordionId">
            <div class="accordion-item">
              <h2 class="accordion-header" [id]="accordionId + '-valid-heading'">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#' + accordionId + '-valid-collapse'" aria-expanded="true" [attr.aria-controls]="accordionId + '-valid-collapse'">
                  Valid airline quotations ({{ validLines.length }})
                </button>
              </h2>
              <div class="accordion-collapse collapse show" [id]="accordionId + '-valid-collapse'" [attr.aria-labelledby]="accordionId + '-valid-heading'" [attr.data-bs-parent]="'#' + accordionId">
                <ng-container *ngTemplateOutlet="quotationsList; context: { listLines: validLines, hideStatus: true, hideConfirmed: false }"></ng-container>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" [id]="accordionId + '-unvalid-heading'">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#' + accordionId + '-unvalid-collapse'" aria-expanded="false" [attr.aria-controls]="accordionId + '-unvalid-collapse'">
                  Unvalid airline quotations ({{ unvalidLines.length }})
                </button>
              </h2>
              <div class="accordion-collapse collapse" [id]="accordionId + '-unvalid-collapse'" [attr.aria-labelledby]="accordionId + '-unvalid-heading'" [attr.data-bs-parent]="'#' + accordionId">
                <ng-container *ngTemplateOutlet="quotationsList; context: { listLines: unvalidLines, hideStatus: false, hideConfirmed: true }"></ng-container>
              </div>
            </div>
          </div>
        }
      </div>

      <ng-template #quotationsList let-listLines="listLines" let-hideStatus="hideStatus" let-hideConfirmed="hideConfirmed">
        <div class="list-group list-group-flush quotations-list-group">
          @for (line of listLines; track line.cotationId ?? line.offerId) {
            <div
              class="list-group-item quotation-item"
              >
              <div class="quotation-head">
                @if (!hideStatus) {
                  <span class="badge" [class.bg-primary]="line.status === EnumEnquiryCotationStatus.waitingForAnswer" [class.bg-success]="['answered', 'confirmed'].indexOf(line.status) !== -1" [class.bg-danger]="line.status === EnumEnquiryCotationStatus.rejected" [class.bg-warning]="line.status === EnumEnquiryCotationStatus.toContact" [innerHtml]="getEnumEnquiryCotationStatusLabel(line.status) | translate"></span>
                }
              </div>
              <div class="quotation-cards">
                <div class="q-card">
                  <div class="q-card-title">{{ 'ENQUIRIES.CONFIRMED_MODAL_CARD_FLIGHT' | translate }}</div>
                  <div class="q-field"><span class="q-label">Airline</span><span [innerHtml]="line.airlineTitle"></span></div>
                  <div class="q-field"><span class="q-label">Country</span><span [innerHtml]="line.airlineCountryTitle"></span></div>
                  <div class="q-field"><span class="q-label">Legs</span><span [innerHtml]="line.legsTitle"></span></div>
                  @if (line.legsId && legsList[line.itineraryId] && line.legsId.length && line.legsId.length < legsList[line.itineraryId].length) {
                    <div class="q-field">
                      <span class="q-label">Warning</span>
                      <fa-icon [icon]="faWarning" [appTooltip]="'ENQUIRIES.CONFIRMED_MODAL_MISSING_LEGS' | translate : { selected: line.legsId.length, total: legsList[line.itineraryId].length }"></fa-icon>
                    </div>
                  }
                  @if (enquiry.type !== EnumEnquiryType.cargo) {
                    <div class="q-field"><span class="q-label">Nb pax</span><span>{{ line.nbPax }}</span></div>
                  }
                  @if (line.notes) {
                    <div class="q-field"><span class="q-label">Notes</span><span [innerHtml]="line.notes"></span></div>
                  }
                </div>
                @if (![EnumEnquiryType.acmi].includes(enquiry.type)) {
                  <div class="q-card">
                    <div class="q-card-title">{{ 'ENQUIRIES.CONFIRMED_MODAL_CARD_AIRCRAFT' | translate }}</div>
                    <div class="q-field"><span class="q-label">Appareil</span><span>{{ line.aircraftTitle?.toUpperCase() }}</span></div>
                    <div class="q-field"><span class="q-label">Âge moyen</span><span>{{ line.ageAverage ? line.ageAverage + ' ans' : ('GENERAL.UNKNOWN' | translate) }}</span></div>
                    @if (line.aircraftErrorMessages.length) {
                      <div class="q-field"><span class="q-label">Alerts</span><fa-icon [icon]="faWarning" [appTooltip]="line.aircraftErrorMessages.join('<hr>')"></fa-icon></div>
                    }
                    @if (enquiry.type !== EnumEnquiryType.cargo) {
                      <div class="q-field"><span class="q-label">Capacité</span><span>{{ line.capacityAircraft }}</span></div>
                    }
                    @if (enquiry.type === EnumEnquiryType.cargo) {
                      <div class="q-field"><span class="q-label">Weight</span><span>{{ line.weightAircraft }} kg</span></div>
                    }
                    @if (enquiry.type === EnumEnquiryType.cargo) {
                      <div class="q-field"><span class="q-label">Volume</span><span [innerHtml]="line.volumeAircraft + ' m<sup>3</sup>'"></span></div>
                    }
                  </div>
                }
                @if ([EnumEnquiryType.acmi].includes(enquiry.type)) {
                  <div class="q-card">
                    <div class="q-card-title">ACMI</div>
                    <div class="q-field"><span class="q-label">Aircraft</span><span>{{ line.acmiAircraftType }} {{ line.acmiAircraftVersion }}</span></div>
                    <div class="q-field"><span class="q-label">Dates</span><span>{{ line.acmiDateStart | date: 'dd/MM/yyyy' }} - {{ line.acmiDateEnd | date: 'dd/MM/yyyy' }}</span></div>
                    <div class="q-field"><span class="q-label">Base</span><span>{{ line.acmiBase }}</span></div>
                    <div class="q-field"><span class="q-label">Routing</span><span>{{ line.acmiRouting?.join(' - ') }}</span></div>
                    <div class="q-field"><span class="q-label">Crew</span><span>{{ line.acmiNbCrew }}</span></div>
                    <div class="q-field"><span class="q-label">Per Diems</span><span>{{ line.acmiPerDiemsIncluded ? ('GENERAL.YES' | translate) : line.acmiPerDiems }}</span></div>
                    <div class="q-field"><span class="q-label">HOTAC</span><span>{{ line.acmiCrewHotacIncluded ? ('GENERAL.YES' | translate) : line.acmiCrewHotac }}</span></div>
                    <div class="q-field"><span class="q-label">Insurance</span><span>{{ !line.acmiHasAdditionalInsurance ? ('GENERAL.NO' | translate) : line.acmiAdditionalInsurance }}</span></div>
                  </div>
                }
                <div class="q-card">
                  <div class="q-card-title">{{ 'ENQUIRIES.CONFIRMED_MODAL_CARD_OPERATING_COSTS' | translate }}</div>
                  <div class="q-field"><span class="q-label">Buying price</span><span>{{ line.buyingPriceInCurrency !== null ? formatPrice(line.buyingPriceInCurrency, line.currency) : '' }}</span></div>
                  @if (enquiry.type !== EnumEnquiryType.cargo) {
                    <div class="q-field"><span class="q-label">Taxes</span><span>{{ line.taxesTotalPaxInCurrency !== null ? formatPrice(line.taxesTotalPaxInCurrency, line.currency) : '' }}</span></div>
                  }
                  @if (enquiry.type !== EnumEnquiryType.cargo) {
                    <div class="q-field"><span class="q-label">Catering</span><span>{{ line.cateringInCurrency !== null ? formatPrice(line.cateringInCurrency, line.currency) : '' }}</span></div>
                  }
                  <div class="q-field"><span class="q-label">Buying price TC and CC</span><span>{{ line.priceNetTTCInCurrency !== null ? formatPrice(line.priceNetTTCInCurrency, line.currency) : '' }}</span></div>
                  @if (enquiry.type !== EnumEnquiryType.cargo) {
                    <div class="q-field"><span class="q-label">Prix pp</span><span>{{ line.pricePPInCurrency !== null ? formatPrice(line.pricePPInCurrency, line.currency) : '' }}</span></div>
                  }
                </div>
                @if (line.sellingPrice) {
                  <div class="q-card">
                    <div class="q-card-title">{{ 'ENQUIRIES.CONFIRMED_MODAL_CARD_SALES_MARGIN' | translate }}</div>
                    <div class="q-field"><span class="q-label">Selling price TC and CC</span><span>{{ line.sellingPriceInCurrency !== null ? formatPrice(line.sellingPriceInCurrency, line.currency) : '' }}</span></div>
                    <div class="q-field"><span class="q-label">Margin</span><span>{{ line.marginInCurrency !== null ? formatPrice(line.marginInCurrency, line.currency) : '' }}</span></div>
                    <div class="q-field"><span class="q-label">Margin %</span><span>{{ line.marginPercentInCurrency !== null ? line.marginPercentInCurrency : '' }}</span></div>
                    @if (enquiry.type !== EnumEnquiryType.cargo) {
                      <div class="q-field"><span class="q-label">Prix vente pp</span><span>{{ line.sellingPricePPInCurrency !== null ? formatPrice(line.sellingPricePPInCurrency, line.currency) : '' }}</span></div>
                    }
                  </div>
                }
              </div>
              @if (!hideConfirmed && isLogged && line.cotationId && line.sellingPrice) {
                <div class="quotation-confirm-inline">
                  <button
                    type="button"
                    class="btn confirm-switch"
                    [class.btn-success]="selectedConfirmedCotationsId.includes(line.cotationId)"
                    [class.btn-primary-outline]="!selectedConfirmedCotationsId.includes(line.cotationId)"
                    (click)="toggleConfirmedCotation(line)"
                    >
                    <fa-icon [icon]="selectedConfirmedCotationsId.includes(line.cotationId) ? faSquareCheck : faSquare"></fa-icon>
                    <span>Airline quotation confirmed?</span>
                  </button>
                  @if (selectedCotationLegsObj[line.cotationId]?.length) {
                    <div class="confirm-legs-cards mt-2">
                      @for (leg of selectedCotationLegsObj[line.cotationId]; track $index) {
                        <div class="card confirm-leg-card">
                          <div class="card-body">
                            <div class="leg-route">{{ getLegRoute(leg) }}</div>
                            <div class="leg-edit-row">
                              <span class="q-label">Departure</span>
                              <div class="leg-time-edit">
                                <div class="input-group input-group-sm">
                                  <input
                                    type="datetime-local"
                                    class="form-control"
                                    [value]="leg.departDateTimeLocal"
                                    [max]="leg.arrivalDateTimeLocal || null"
                                    (input)="onLegDateTimeInput(leg, 'depart', 'local', $any($event.target).value)"
                                    />
                                  <span class="input-group-text">LT</span>
                                </div>
                                <div class="input-group input-group-sm">
                                  <input
                                    type="datetime-local"
                                    class="form-control"
                                    [value]="leg.departDateTimeUtc"
                                    [max]="leg.arrivalDateTimeUtc || null"
                                    (input)="onLegDateTimeInput(leg, 'depart', 'utc', $any($event.target).value)"
                                    />
                                  <span class="input-group-text">UTC</span>
                                </div>
                              </div>
                            </div>
                            <div class="leg-edit-row">
                              <span class="q-label">Arrival</span>
                              <div class="leg-time-edit">
                                <div class="input-group input-group-sm">
                                  <input
                                    type="datetime-local"
                                    class="form-control"
                                    [value]="leg.arrivalDateTimeLocal"
                                    [min]="leg.departDateTimeLocal || null"
                                    (input)="onLegDateTimeInput(leg, 'arrival', 'local', $any($event.target).value)"
                                    />
                                  <span class="input-group-text">LT</span>
                                </div>
                                <div class="input-group input-group-sm">
                                  <input
                                    type="datetime-local"
                                    class="form-control"
                                    [value]="leg.arrivalDateTimeUtc"
                                    [min]="leg.departDateTimeUtc || null"
                                    (input)="onLegDateTimeInput(leg, 'arrival', 'utc', $any($event.target).value)"
                                    />
                                  <span class="input-group-text">UTC</span>
                                </div>
                              </div>
                            </div>
                            @if (getLegDateValidationMessage(leg)) {
                              <div class="text-danger leg-error text-center">
                                {{ getLegDateValidationMessage(leg) }}
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!hideConfirmed && isLogged && !line.cotationId) {
                <div class="text-danger text-center quotation-alert">
                  {{ 'ENQUIRIES.CONFIRMED_MODAL_COTATION_NOT_FILLED' | translate }}
                </div>
              }
              @if (!hideConfirmed && isLogged && line.cotationId && !line.sellingPrice) {
                <div class="text-danger text-center quotation-alert">
                  {{ 'ENQUIRIES.CONFIRMED_MODAL_COTATION_NO_SELLING_PRICE' | translate }}
                </div>
              }
            </div>
          }
        </div>
      </ng-template>

      @if (lines.length) {
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-success" (click)="save()" [disabled]="!selectedConfirmedCotationsId.length || hasInvalidSelectedLegs()">
            <fa-icon [icon]="faCheck"></fa-icon>
            {{ 'GENERAL.SAVE' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
